function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent, Children, cloneElement } from "react";
import Carousel from "nuka-carousel";
import Button from "/components/core/button/button-component";
import { isFunction } from "services/utils-service";
import BottomCenterPoints from "./decorators/bottom-center-points";
const getSettings = ({ bottomCenterExtraProps })=>{
    return {
        renderBottomCenterControls: ({ currentSlide, slideCount, goToSlide, slidesToScroll })=>{
            return /*#__PURE__*/ _jsx(BottomCenterPoints, {
                currentSlide: currentSlide,
                slideCount: slideCount,
                goToSlide: goToSlide,
                slidesToScroll: slidesToScroll,
                bottomCenterExtraProps: bottomCenterExtraProps
            });
        }
    };
};
class CarouselGallary extends PureComponent {
    afterCarouselSlide(slideIndex) {
        const { afterSlide } = this.props;
        this.setState({
            carouselSlideIndex: slideIndex
        }, ()=>{
            if (isFunction(afterSlide)) {
                afterSlide(slideIndex);
            }
        });
    }
    render() {
        const { children, bottomCenterExtraProps } = this.props;
        const { carouselSlideIndex } = this.state;
        return /*#__PURE__*/ _jsx(Carousel, _object_spread_props(_object_spread({}, getSettings({
            bottomCenterExtraProps
        }), this.props), {
            afterSlide: this.afterCarouselSlide,
            children: Children.map(children, (child, index)=>/*#__PURE__*/ cloneElement(child, {
                    isCurrentSlide: carouselSlideIndex == index
                }))
        }));
    }
    constructor(props){
        super(props);
        this.state = {
            carouselSlideIndex: props.slideIndex
        };
        this.afterCarouselSlide = this.afterCarouselSlide.bind(this);
    }
}
export { CarouselGallary as default };
CarouselGallary.defaultProps = {
    bottomCenterExtraProps: {}
};
